module.exports = __webpack_public_path__ + "img/1db1add.png";